import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {buildFeatureUrl, usePlantIdFromHierarchyId, useSuiteHierarchyId} from '@hproduce/suite-core'
import {ThemeProvider} from '@mui/material'
import {Navigate, Outlet, RouteObject} from 'react-router'

import {
  DOWNTIME_OVERVIEW_PATH,
  DOWNTIME_STATISTICS_PATH,
  DOWNTIME_STOPPAGE_DETAILS_FOR_CODE_PATH,
  DOWNTIME_STOPPAGE_DETAILS_PATH,
  DOWNTIME_STOPPAGES_PATH
} from '../consts'
import {downtimeDashboardFeatureTranslations} from '../localization'
import {
  DownTimeDashboard,
  DowntimeStoppagesDetails,
  DowntimeStoppagesDetailsForCode,
  DowntimeStoppagesStats,
  EquipmentKpiStats
} from '../pages'
import {
  DowntimePlantIdProvider,
  DowntimeTrackAnalysisWrapper,
  StoppagesStatsTimeRangeProvider
} from '../providers'

export const DowntimeFeatureProviders: React.FC<{children: React.ReactNode}> = ({children}) => (
  <FeatureTranslationsLoader translations={downtimeDashboardFeatureTranslations}>
    <DowntimeTrackAnalysisWrapper>
      <StoppagesStatsTimeRangeProvider>{children}</StoppagesStatsTimeRangeProvider>
    </DowntimeTrackAnalysisWrapper>
  </FeatureTranslationsLoader>
)

const SuiteDowntimeDashboardContent = () => {
  const plantId = usePlantIdFromHierarchyId()

  if (!plantId) {
    return null
  }

  return (
    <DowntimePlantIdProvider plantId={plantId}>
      <DowntimeFeatureProviders>
        <Outlet />
      </DowntimeFeatureProviders>
    </DowntimePlantIdProvider>
  )
}

const SuiteDowntimeOverviewPage = () => {
  const hierarchyId = useSuiteHierarchyId()

  return (
    <DownTimeDashboard
      useParentRelativePaths
      stoppageListTo={buildFeatureUrl('StoppageList', hierarchyId)}
    />
  )
}

const SuiteDowntimeDashboardRouteWrapper = () => {
  return (
    <ThemeProvider theme={useFundamentalMuiTheme()}>
      <SuiteDowntimeDashboardContent />
    </ThemeProvider>
  )
}

export const downtimeDashboardRoutes: RouteObject = {
  path: '*',
  element: <SuiteDowntimeDashboardRouteWrapper />,
  children: [
    {
      index: true,
      element: <Navigate to={DOWNTIME_OVERVIEW_PATH} replace />
    },
    {
      path: DOWNTIME_OVERVIEW_PATH,
      element: <SuiteDowntimeOverviewPage />
    },
    {
      path: DOWNTIME_STATISTICS_PATH,
      element: <EquipmentKpiStats />
    },
    {
      path: DOWNTIME_STOPPAGES_PATH,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: <DowntimeStoppagesStats />
        },
        {
          path: DOWNTIME_STOPPAGE_DETAILS_PATH,
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <DowntimeStoppagesDetails />
            },
            {
              path: DOWNTIME_STOPPAGE_DETAILS_FOR_CODE_PATH,
              element: <DowntimeStoppagesDetailsForCode />
            }
          ]
        }
      ]
    }
  ]
}
